export default "__VITE_ASSET__28a6bc92__"